/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Log_Status_Skipped_UnlinkedInputs */

const he_account_delivery_log_status_skipped_unlinked = /** @type {(inputs: Account_Delivery_Log_Status_Skipped_UnlinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דולג (לא מחובר)`)
};

const en_account_delivery_log_status_skipped_unlinked = /** @type {(inputs: Account_Delivery_Log_Status_Skipped_UnlinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skipped (not linked)`)
};

/**
* | output |
* | --- |
* | "Skipped (not linked)" |
*
* @param {Account_Delivery_Log_Status_Skipped_UnlinkedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_log_status_skipped_unlinked = /** @type {((inputs?: Account_Delivery_Log_Status_Skipped_UnlinkedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Log_Status_Skipped_UnlinkedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_log_status_skipped_unlinked(inputs)
	return en_account_delivery_log_status_skipped_unlinked(inputs)
});